import reducer from './reducer';
import * as actions from './actions';
import * as constants from './constants';
import * as selectors from './selectors';
import saga from './saga';
import localPersistence from './localPersistence';

export default {
  reducer: reducer,
  actions: actions,
  constants: constants,
  selectors: selectors,
  saga: saga,
  localPersistence: localPersistence,
};



// WEBPACK FOOTER //
// ./src/storeState/ui/index.js